import { Coding } from "@medplum/fhirtypes";

import { DEFAULT_SERVICE_DATE_TIMEZONE } from "@/shared/practice-timezone/constants/service-date-timezone";

/**
 * Builds a service-date timezone coding from the browser's IANA timezone.
 *
 * @returns Browser timezone coding, or the practice default when unavailable.
 */
export function getBrowserServiceDateTimezone(): Coding {
  const ianaTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (!ianaTimezone) {
    return { ...DEFAULT_SERVICE_DATE_TIMEZONE };
  }

  return {
    system: DEFAULT_SERVICE_DATE_TIMEZONE.system,
    code: ianaTimezone,
    display: ianaTimezone,
  };
}
